import { OnboardingStep } from '../enums/onboarding.enums';
import { AppRouting } from '../../../services/appRoutingResolver';

export const ONBOARDING_STEP_TO_ROUTE: Partial<Record<OnboardingStep, string>> = {
  [OnboardingStep.SetupProfile]: AppRouting.ROUTES.ONBOARDING_SETUP_PROFILE,
  [OnboardingStep.EmailVerification]: AppRouting.ROUTES.ONBOARDING_EMAIL_VERIFICATION,
  [OnboardingStep.OnboardingCompleted]: AppRouting.ROUTES.ONBOARDING_COMPLETED,
};
